import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Главная ${ctx.brand}`,
    languageButtonLabel: `Язык`,
    languageModalTitle: `Выберите язык`,
    languageModalCloseLabel: `Закрыть меню языков`,
  },
  languageOptions: {
    'en-US': {
      label: `Английский`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Английский (Кения)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Английский (Нигерия)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Английский (Сингапур)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Португальский`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Немецкий`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Испанский`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Французский`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Итальянский`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Нидерландский`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Скандинавский & балтийский`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Японский`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Корейский`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Путунхуа`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Кантонский`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Тайский`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Хинди`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Персидский`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Русский`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Арабский`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Марокканский арабский`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Выберите язык`,
    closeLabel: `Закрыть меню языков`,
  },
  languageHint: (ctx) => `Переключайтесь между ${ctx.localesCount}+ языками одним касанием.`,
  readPagePrompt: ({languageLabel}) => `Прочитать эту страницу на ${languageLabel}.`,
};
